import { gql } from '@apollo/client';

import sampleEvent from 'api/sample-events/sampleEvent';

export const mutation = gql`
  mutation InsertSampleEvent($sample_events_insert_input: sample_events_insert_input!) {
    sampleEvent: insert_sample_events_one(object: $sample_events_insert_input) {
      ...sampleEvent
    }
  }
  ${sampleEvent}
`;

export function buildVariables({ name, description, eventJson }) {
  return {
    sample_events_insert_input: {
      name,
      description,
      eventJson,
    },
  };
}
